export default String.raw`
.popupBanner {
    &__body {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        max-width: 330px;
        width: 100%;
        height: 519px;
        padding-right: 8px;

        &-close {
            right: 16px;
        }

        &-header {
            padding-left: 16px;
            padding-right: 8px;

            h2 {
                width: 200px;
                @include h3-headline;
                padding: 0;
            }
        }
    
        &-image {
            width: calc(100% + 16px);

            a {
                border-radius: unset;
            }
        }

        &-content {
            min-height: unset;
            padding-left: 16px;
            padding-right: 8px;
            gap: unset;

            &-button {
                margin-top: 24px;
            }

            &:last-child {
                margin-bottom: 8px;
            }

            &-close {
                display: block;
            }
        }
    }
}
`